import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { HeroSection } from '../components/HeroSection';
import { MusicInGentofteBanner } from '../components/MusicInGentofteBanner';
import { PartnerSection } from '../components/PartnerSection';
import { PopupBanner } from '../components/PopupBanner';
import { ProblemSection } from '../components/ProblemSection';
import { EventOperationsSection } from '../components/EventOperationsSection';
import { HardwareSection } from '../components/HardwareSection';
import { UseCasesSection } from '../components/UseCasesSection';
import { CTASection } from '../components/CTASection';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <MusicInGentofteBanner />
        <HeroSection />
        <PartnerSection />
        <ProblemSection />
        <EventOperationsSection />
        <HardwareSection />
        <UseCasesSection />
        <CTASection />
      </main>
      <PopupBanner />
      <Footer />
    </div>
  );
};

export default HomePage;
